// App.js
import React, { useEffect, useState, useCallback } from 'react';
import { useDeepCompareEffect } from 'react-use';
import { Route, Switch, Redirect, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import queryString from 'query-string';
import { jwtDecode } from 'jwt-decode';

import { Grid, Card, Box, InputLabel, MenuItem, Select } from '@mui/material';

import debounce from 'lodash.debounce'; 

import Cube from './components/Cube';
import Map from './components/Map';
import Search from './components/Search';
import FpzTable from './components/FpzTable';

import { gisActions } from './actions';

// TEMP
import tempDirectionalSurveys from "./tempData/directionalSurveys.json";
import Offset_1H from "./tempData/14242/Offset_1H-Kirk_01_04H_Surveys.json";
import Offset_2H from "./tempData/14242/Offset_2H-Kirk_01_501H_Surveys.json";
import Treating_Well_1H from "./tempData/14242/Treating_Well_1H-Kirk_01_03H_Surveys.json";
import Treating_Well_2H from "./tempData/14242/Treating_Well_2H-Kirk_01_05H_Surveys.json";
import Treating_Well_3H from "./tempData/14242/Treating_Well_3H-Kirk_01_502H_Surveys.json";


function App() {
  const dispatch = useDispatch();

  const fpzState = useSelector((state) => state.fpzReducer);

  const [directionalSurveys, setDirectionalSurveys] = useState([]);
  const [toggleCartofactWells, setToggleCartofactWells] = useState(true);
  
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(false);
  const [cartofactWells, setCartofactWells] = useState([]);
  const [fpzRadius, setFpzRadius] = useState(500);
  const [fpzRadius2, setFpzRadius2] = useState(null);
  const [boundingBox, setBoundingBox] = useState(null);
  const [selected, setSelected] = useState(null);
  const [cubeRender, setCubeRender] = useState(null);
  const [lockCartofactWells, setLockCartofactWells] = useState(false);


  const fetchCartofactWells =  useCallback(
    debounce(async (params) => {
      try {
        console.log('fetchCartofactWells', params);
        setLoading(true);
        const cartofact = await dispatch(gisActions.getCartofactWells(params));
        setCartofactWells(cartofact);
      } catch (error) {
        console.error('Error fetching cartofact wells:', error);
      } finally {
        setLoading(false);
      }
    }, 1500),
    []
  );

  const handleChangeRadius = (event) => {
    setFpzRadius(event.target.value);
  };

  const renderCube = () => {
    console.log('renderCube');
    setCubeRender(null);
    setTimeout(() => {
      console.log('timeout renderCube');
      setCubeRender(
        <Cube
          directionalSurveys={directionalSurveys}
          selected={selected}
        />
      );
    }, 500);
  };

  useEffect(() => {
    if (tempDirectionalSurveys) {
      setDirectionalSurveys(tempDirectionalSurveys);
    }
  }, []);

  useDeepCompareEffect(() => {
    if (toggleCartofactWells === true && boundingBox) {
      const params = {
        boundingBox,
        filter,
      }
      console.log('fetchCartofactWells', params);
      fetchCartofactWells(params);
    } else {
      setCartofactWells([]);
    }
  }, [toggleCartofactWells, boundingBox, filter]);

  useDeepCompareEffect(() => {
    if (directionalSurveys?.length > 0) {
      console.log('renderCube');
      renderCube();
    } else {
      setCubeRender(null);
    }
  }, [directionalSurveys]);

  

  const surveyData = directionalSurveys[0]?.coordinates || [];
  // console.log('surveyData', surveyData);
  
  return (
    <div>
      <h2>Abra Controls Directive 83 (FPZ)</h2>

      <Grid container
        spacing={2}
      >
        <Grid item xs={8} md={4} >
          <Search
            filter={filter}
            setFilter={setFilter}
            loading={loading}
          />
        </Grid>
        <Grid item xs={4} md={2}>
          <Select
            labelId="select-fpz-radius-label"
            id="select-fpz-radius"
            value={fpzRadius}
            label="Radius"
            onChange={handleChangeRadius}
          >
            <MenuItem value={200}>200 meters</MenuItem>
            <MenuItem value={300}>300 meters</MenuItem>
            <MenuItem value={400}>400 meters</MenuItem>
            <MenuItem value={500}>500 meters</MenuItem>
            <MenuItem value={750}>750 meters</MenuItem>
            <MenuItem value={1000}>1000 meters</MenuItem>
            <MenuItem value={1125}>1125 meters</MenuItem>
            <MenuItem value={1250}>1250 meters</MenuItem>
            <MenuItem value={1500}>1500 meters</MenuItem>
            <MenuItem value={1750}>1750 meters</MenuItem>
            <MenuItem value={2000}>2000 meters</MenuItem>
            <MenuItem value={2500}>2500 meters</MenuItem>
            <MenuItem value={3000}>3000 meters</MenuItem>
            <MenuItem value={3500}>3500 meters</MenuItem>
            <MenuItem value={4000}>4000 meters</MenuItem>
            <MenuItem value={4500}>4500 meters</MenuItem>
            <MenuItem value={5000}>5000 meters</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={12} md={6}>
          {selected && (
            <>
              <strong>Selected Well:</strong>
              <div>{selected?.unique_identifier}</div>
              <div>{selected?.well_name}</div>
              <div>{selected?.operator}</div>
            </>
          )}
        </Grid>
      </Grid>


      <Grid container
        spacing={2}
        sx={{
          minHeight: 'calc(100vh - 100px)', 
        }}
      >
        <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
          <Card sx={{ minHeight: '400px', height: '100%', padding: '0px' }}>
            <Map
              sx={{ flex: 1 }}
              directionalSurveys={directionalSurveys}
              setDirectionalSurveys={setDirectionalSurveys}
              toggleCartofactWells={toggleCartofactWells}
              fetchCartofactWells={fetchCartofactWells}
              setCartofactWells={setCartofactWells}
              cartofactWells={cartofactWells}
              setBoundingBox={setBoundingBox}
              boundingBox={boundingBox}
              setSelected={setSelected}
              selected={selected}
              fpzRadius={fpzRadius}
              setFilter={setFilter}
            />
          </Card>
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
          <Card sx={{ minHeight: '400px', height: '100%', padding: '0px' }}>
            {cubeRender}
          </Card>
        </Grid>
        { /* table */}
        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
          <Card sx={{ border: '1px solid #ccc', borderRadius: 2, padding: 2 }}>
            <strong>Shared Offset Wells - FPZ</strong><br />
            Choose a well from the map to see the directional survey data.
            {(directionalSurveys && selected && directionalSurveys?.length > 0) && (
              <FpzTable
                directionalSurveys={directionalSurveys}
                selected={selected}
                fpzRadius={fpzRadius}
              />
              )}
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}

export default App;
